import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, RootContext, Wrapper } from '@skylab-angular-shared/core';
import { SaleGridQuery, SaleGridQueryHandlerBase } from '@skylab-shared/business';
import { KsefDeadlineDateCalculator } from '../../ksef/ksef-deadline-date-calculator.service';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(SaleGridQuery)
@Wrapper(SaleGridQueryHandlerBase)
export class SaleGridQueryHandler {
    public constructor(
        http: Http,
        rootContext: RootContext,
        ksefDeadlineCalculator: KsefDeadlineDateCalculator
    ) { }
}
